"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroupAdapter = exports.RadioGroup = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RadioGroup = require("../../microFields/RadioGroup");

var _fieldUtils = require("../../microFields/fieldUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* play nice with redux-form but can be overridden with customOptions */
var RadioGroup = function RadioGroup(_ref) {
  var input = _ref.input,
      cashbotName = _ref.cashbotName,
      legend = _ref.legend,
      radioOptions = _ref.radioOptions,
      styleType = _ref.styleType,
      containerClass = _ref.containerClass,
      radioButtonClass = _ref.radioButtonClass,
      role = _ref.role,
      radioButtonRole = _ref.radioButtonRole,
      checkmarkClass = _ref.checkmarkClass,
      customOptions = _ref.customOptions,
      doFocus = _ref.doFocus,
      defaultValue = _ref.defaultValue;

  var handleChange = function handleChange(newValue) {
    if (customOptions.onChange) {
      customOptions.onChange(newValue);
    } else {
      input.onChange(newValue);
    }
  };

  return _react.default.createElement(_RadioGroup.RadioGroup, {
    name: input.name,
    defaultValue: defaultValue || input.value,
    legend: legend,
    cashbotName: cashbotName,
    styleType: styleType,
    containerClass: containerClass,
    radioButtonClass: radioButtonClass,
    role: role,
    radioButtonRole: radioButtonRole,
    checkmarkClass: checkmarkClass,
    radioOptions: radioOptions,
    handleChange: handleChange,
    doFocus: doFocus
  });
};

exports.RadioGroup = RadioGroup;
RadioGroup.defaultProps = {
  styleType: 'radiobutton',
  containerClass: null,
  radioButtonClass: 'radio-button',
  role: 'radiogroup',
  radioButtonRole: 'radio',
  checkmarkClass: 'radio-icon',
  customOptions: {},
  doFocus: false,
  defaultValue: ''
};
RadioGroup.propTypes = {
  input: _propTypes.default.object.isRequired,
  legend: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  styleType: _propTypes.default.oneOf(['radiobutton', 'picker', 'checkedpicker']),
  containerClass: _propTypes.default.string,
  radioButtonClass: _propTypes.default.string,
  role: _propTypes.default.string,
  radioButtonRole: _propTypes.default.string,
  checkmarkClass: _propTypes.default.string,
  radioOptions: _fieldUtils.radioOptionsPropTypes.isRequired,
  customOptions: _propTypes.default.shape({
    onChange: _propTypes.default.func
  }),
  doFocus: _propTypes.default.bool,
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool])
};
var RadioGroupAdapter = RadioGroup;
exports.RadioGroupAdapter = RadioGroupAdapter;